/* Consent bridge for this store's existing manual GA4 tag and native preference UI. */
(() => {
  'use strict';
  if (window.cardclubPrivacyBridgeStarted) return;
  window.cardclubPrivacyBridgeStarted = true;
  const measurementId = 'G-2E4G38472Z';
  const disableKey = 'ga-disable-' + measurementId;
  const root = document.documentElement;
  let started = false, bannerLoading = null;
  window[disableKey] = true;
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
  const denied = () => ({analytics_storage:'denied', ad_storage:'denied', ad_user_data:'denied', ad_personalization:'denied'});
  window.gtag('consent', 'default', denied());
  root.dataset.ccAnalyticsAllowed = 'false';
  function removeOwnAnalyticsCookies() {
    // Only this Google destination's two known cookies, never Shopify cookies.
    const names = ['_ga', '_ga_' + measurementId.replace(/^G-/, '').replace(/-/g, '_')];
    const host = location.hostname;
    const domains = [null, host, host.startsWith('www.') ? host.slice(4) : host];
    for (const name of names) for (const domain of new Set(domains)) {
      document.cookie = name + '=; Max-Age=0; Path=/; SameSite=Lax; Secure' + (domain ? '; Domain=' + domain : '');
    }
  }
  function sync() {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    let allowed = false, ready = false;
    try { ready = typeof privacy?.analyticsProcessingAllowed === 'function'; allowed = ready && privacy.analyticsProcessingAllowed() === true; } catch (_) {}
    window[disableKey] = !allowed;
    root.dataset.ccAnalyticsAllowed = String(allowed);
    root.dataset.ccPrivacyApiReady = String(ready);
    if (!allowed) {
      if (started) window.gtag('consent', 'update', denied());
      if (ready) removeOwnAnalyticsCookies();
      return;
    }
    window.gtag('consent', 'update', {...denied(), analytics_storage:'granted'});
    if (started) return;
    started = true;
    window.gtag('js', new Date());
    window.gtag('config', measurementId, {allow_google_signals:false, allow_ad_personalization_signals:false});
    if (!document.querySelector('[data-cc-consented-ga4]')) {
      const script = document.createElement('script'); script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(measurementId);
      script.setAttribute('data-cc-consented-ga4',''); document.head.appendChild(script);
    }
  }
  document.addEventListener('visitorConsentCollected', sync);
  function start(attempt = 0) {
    if (typeof window.Shopify?.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], error => { if (!error) sync(); });
    } else if (attempt < 8) window.setTimeout(() => start(attempt + 1), 250);
  }
  start();
  async function banner() {
    if (typeof window.privacyBanner?.showPreferences === 'function') return window.privacyBanner;
    if (!bannerLoading) bannerLoading = new Promise((resolve, reject) => {
      const script = document.createElement('script'); script.async = true;
      script.src = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
      script.onload = () => typeof window.privacyBanner?.showPreferences === 'function' ? resolve(window.privacyBanner) : reject(new Error('Preferences API unavailable'));
      script.onerror = () => reject(new Error('Preferences API unavailable'));
      document.head.appendChild(script);
    }).catch(error => { bannerLoading = null; throw error; });
    return bannerLoading;
  }
  async function openPreferences(button) {
    const status = document.querySelector('[data-cc-cookie-status]');
    if (button?.dataset.ccOpening === 'true') return;
    if (button) button.dataset.ccOpening = 'true';
    if (status) status.textContent = window.CardclubCustomUI?.t('privacy.opening') || 'Opening cookie preferences…';
    document.dispatchEvent(new CustomEvent('cardclub:privacy-open'));
    try {
      const api = await banner(); await api.showPreferences();
      // The native API may resolve before its asynchronous renderer finishes.
      await new Promise((resolve, reject) => {
        const ready = () => { const wrapper=document.getElementById('shopify-pc__prefs');return wrapper&&getComputedStyle(wrapper).display!=='none'&&document.getElementById('shopify-pc__prefs__dialog'); };
        if (ready()) { resolve(); return; }
        let timer;const observer=new MutationObserver(() => { if(ready()){observer.disconnect();window.clearTimeout(timer);resolve();} });
        observer.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['style','hidden','class']});
        timer=window.setTimeout(()=>{observer.disconnect();reject(new Error('Native preferences did not render'));},12000);
      });
      if (status) status.textContent = '';
    }
    catch (_) { if (status) status.textContent = window.CardclubCustomUI?.t('privacy.error') || 'Cookie preferences could not open. Please try again.'; }
    finally { if (button) delete button.dataset.ccOpening; }
  }
  document.addEventListener('click', event => {
    const target = event.target.closest?.('[data-cc-cookie-settings]');
    if (!target) return; event.preventDefault(); openPreferences(target);
  });
  if (location.hash === '#cookie-preferences') openPreferences();
})();
